import { FC } from "react"
import { LoadingOutlined } from "@ant-design/icons"

import styles from "./XCard.module.scss"

type XCardExtensions = {
  Loader: typeof Loader
  Title: typeof Title
  Subtitle: typeof Subtitle
  Empty: typeof Empty
  Actions: typeof Actions
}

type XCardActionsExtensions = {
  Button: typeof Button
}

type XCardProps = {
  children: any
  style?: any
}

type XCardActionsProps = {
  children: any
}

type XCardButtonProps = {
  children: any
  onClick: (ev: any) => void
}

type XCardLoaderProps = {}

type XCardTitleProps = {
  children: any
}

export const XCard: FC<XCardProps> & XCardExtensions = ({
  children, style
}) => {
  return (
    <>
      <div className={styles.xcard} style={style}>{children}</div>
    </>
  )
}

const Actions: FC<XCardActionsProps> & XCardActionsExtensions = ({
  children
}) => {
  return (
    <>
      <div className={styles.xcard_actions}>
        {children}
      </div>
    </>
  )
}

const Button: FC<XCardButtonProps> = ({
  children, onClick
}) => {
  return (
    <>
      <button onClick={onClick}>{children}</button>
    </>
  )
}

Actions.Button = Button

type EmptyProps = {
  children?: any
  style?: any
}

const Empty: FC<EmptyProps> = ({
  children, style
}) => {
  return (
    <>
      <div className={styles.empty} style={style}>{children}</div>
    </>
  )
}

const Subtitle: FC<XCardTitleProps> = ({ children }) => {
  return (
    <>
      <h5>{children}</h5>
    </>
  )
}

const Title: FC<XCardTitleProps> = ({
  children
}) => {
  return (
    <>
      <h3>{children}</h3>
    </>
  )
}

const Loader: FC<XCardLoaderProps> = () => {
  return (
    <>
      <div className={styles.xcard_loader}><LoadingOutlined spin rev={""} /></div>
    </>
  )
}

XCard.Loader = Loader
XCard.Title = Title
XCard.Subtitle = Subtitle
XCard.Empty = Empty
XCard.Actions = Actions